import { NOT_APPLICABLE_FIELD_VALUE } from '../constants/datasheet'

export const regulationValidate = (value: string): boolean => {
  if (value) {
    const regex = /^(?!.*[./-]{2,})[0-9][0-9./-]{2,18}[0-9]$/
    const isValid = regex.test(value) && value.length >= 4 && value.length <= 20

    return isValid || value === NOT_APPLICABLE_FIELD_VALUE
  }

  return true
}
